import React        from 'react';

import WP_API       from './apis/wp-api';
import Loading      from './bits/Loading';
import Error        from './bits/Error';
import Pagination   from './ui/Pagination';
import ItemsList    from './views/ItemsList';


class App extends React.Component {
    //hashArr 0 = page, 1 = selectedItem id, etc
    hashArr = (window.location.hash ? window.location.hash.replace('#', '').split("/") : [false, false]);

    init_state = {
        contentType: (window.contentType || 'vr_images'),
        loading: true,
        error: false,
        selectedItem: null,
        items: null,
        totalItems: null,//not used, but is set
        itemsPerPage: parseInt((window.itemsPerPage || 12)),
        currentPage: parseInt((this.hashArr[0] || 1)),
        totalPages: 1
    }
    state = this.init_state;


    componentDidMount(){

        this.loadData(this.state.currentPage);

            if(window.visualViewport){
                setTimeout(function () {
                    let viewport = document.querySelector("meta[name=viewport]");
                    viewport.setAttribute("content", "height=" + window.visualViewport.height + ", width=" + window.visualViewport.width + ", initial-scale=1.0");
                }, 300);
            }
    }


    loadData = async (p)=> {

        const queryUrl = '/wp-json/wp/v2/' + this.state.contentType + '/?_embed&filter[orderby]=date&order=desc&per_page=' + this.state.itemsPerPage + '&page=' + p;
        //console.log(queryUrl);

        await WP_API.get(queryUrl)
        .then(response => {
            //console.log(response);

            this.setState({
                loading: false,
                error: false,
                items: response.data,
                totalItems: parseInt(response.headers['x-wp-total']),
                totalPages: parseInt(response.headers['x-wp-totalpages']),
                currentPage: p,
                selectedItem: (parseInt(this.hashArr[1]) || null)
            });
        })
        .catch(error => {
            console.log(error);
            this.setState({error: true, loading: false});
        });

    }

    
    onPageSelect =(p)=> {

        p = parseInt(p);

        this.setState({
            loading: true
        });

        this.loadData(p);
    }


    onItemSelect =(item)=>{
        this.setState({selectedItem: item.id});
        window.location.href = item.link + '#'+ this.state.currentPage + '/' + item.id;
    }


    render(){

            if(!this.state.items) return <Loading />
            if(this.state.error) return <Error />

        return(
                <>  
                    <Pagination selector="pagesSelectorListTop" page={this.state.currentPage} totalPages={this.state.totalPages} onPageSelect={this.onPageSelect} loading={this.state.loading} />
                    <ItemsList items={this.state.items} onItemSelect={this.onItemSelect} selectedItem={this.state.selectedItem} />
                    <Pagination selector="pagesSelectorListBottom" page={this.state.currentPage} totalPages={this.state.totalPages} onPageSelect={this.onPageSelect}  loading={this.state.loading} />
                </>
            )
        }
}


export default App;